import React, { useContext, useEffect, useState } from 'react';
import { ListGroup, Row, Col, Image, Button, Container } from 'react-bootstrap';
import './product_styles.css'
import ProductModal from './ProductModal/ProductModal';
import { OrderContext } from '../../context/OrderContext';
import useProductSet from '../../hook/useProductSet';
import { useNavigate } from 'react-router-dom';
import useCreateRefund from '../../hook/useCreateRefund';
import { FaRegCircleCheck } from "react-icons/fa6";
import { toast } from 'react-toastify';



const ProductList = () => {


  const [showModal, setShowModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [quantities, setQuantities] = useState({});
  const navigate = useNavigate();
  const {dataProducts} = useCreateRefund()


  const { orderProduct, process, orderNumber, email, refundProduct} = useContext(OrderContext);
  const {postProducts} = useProductSet(); 


  // useEffect(() => {
  //   if (orderNumber && email) {
  //     dataProducts(orderNumber, email);
  //   }
  // }, [orderNumber, email]);

  useEffect(() => {
    if (!orderProduct && orderNumber && email) {
      dataProducts(orderNumber, email);
    }
  }, [orderProduct, orderNumber, email]);

  // Her product için tüm iade claim item'larındaki requested_quantity toplamı
  const getRequestedQuantity = (productId, options = {}) => {
    const { submittedOnly = false } = options;
    if (!refundProduct || !Array.isArray(refundProduct)) return 0;
    let totalRequested = 0;
    for (const claim of refundProduct) {
      if (claim?.type !== 'İade Talebi') {
        continue;
      }
      if (submittedOnly && String(claim?.Status) <= '0') {
        continue;
      }
      if (claim.items && Array.isArray(claim.items)) {
        claim.items.forEach((item) => {
          if (item?.order_product?.Id === productId) {
            totalRequested += Number(item?.requested_quantity) || 0;
          }
        });
      }
    }
    return totalRequested;
  };

  const isFullyRequested = (product) => {
    const totalQty = Number(product?.Count) || 1;
    return getRequestedQuantity(product.Id) >= totalQty;
  };

  const hasSubmittedClaimForProduct = (productId) => {
    if (!refundProduct || !Array.isArray(refundProduct)) return false;
    return refundProduct.some((claim) => {
      if (claim?.type !== 'İade Talebi') {
        return false;
      }
      if (String(claim?.Status) <= '0') {
        return false;
      }
      return Array.isArray(claim?.items) && claim.items.some((item) => item?.order_product?.Id === productId);
    });
  };

  const getMaxSelectableQuantity = (product) => {
    const totalQty = Number(product?.Count) || 1;
    const submittedRequested = getRequestedQuantity(product.Id, { submittedOnly: true });
    return Math.max(totalQty - submittedRequested, 1);
  };

  const handleShowModal = (product) => {
    // Ürün adedi tamamen talep edildiyse modal açma
    if (isFullyRequested(product)) {
      toast.info('Bu ürün için iade talebi açılmıştır.', {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      return;
    }

    setSelectedProduct(product);
    setShowModal(true);
    // Use selected quantity from stepper if available
    const qtyToSend = product?.Count && Number(product.Count) > 1
      ? Math.min(
          Math.max(parseInt(quantities[product.Id] || 1, 10), 1),
          getMaxSelectableQuantity(product)
        )
      : undefined;
    postProducts(product.Id, qtyToSend);
  };

  const increaseQty = (e, product) => {
    e.stopPropagation();
    if (isFullyRequested(product) || hasSubmittedClaimForProduct(product.Id)) {
      return; // Tamamlanan ürünlerde değişiklik yapma
    }
    setQuantities((prev) => {
      const current = parseInt(prev[product.Id] || 1, 10);
      const maxSelectable = getMaxSelectableQuantity(product);
      const next = Math.min(current + 1, maxSelectable);
      const newQuantities = { ...prev, [product.Id]: next };
      // Quantity değiştiğinde backend'e gönder
      if (next !== current) {
        postProducts(product.Id, next);
      }
      return newQuantities;
    });
  };

  const decreaseQty = (e, product) => {
    e.stopPropagation();
    if (isFullyRequested(product) || hasSubmittedClaimForProduct(product.Id)) {
      return; // Tamamlanan ürünlerde değişiklik yapma
    }
    setQuantities((prev) => {
      const current = parseInt(prev[product.Id] || 1, 10);
      const next = Math.max(current - 1, 1);
      const newQuantities = { ...prev, [product.Id]: next };
      // Quantity değiştiğinde backend'e gönder
      if (next !== current) {
        postProducts(product.Id, next);
      }
      return newQuantities;
    });
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  function formatCurrency(amount) {
    return new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY' }).format(amount);
  }

  const map_product = orderProduct?.OrderProducts

  return (
    <>
    <Container className="d-flex flex-column justify-content-center align-items-center product-list-container" style={{ minHeight: '100vh' }}>
    <Row className="w-100 justify-content-center">
      <Col md={6}>
        <ListGroup>
        {map_product?.map((product) => (
          <ListGroup.Item 
            key={product.Id} 
            className="product-card" 
            onClick={() => handleShowModal(product)}
          >
            <Row className="g-1 align-items-center row_box">
              <Col xs={3} md={3} l={3} className="product-image-col">
                <Image src={product.image} alt={product.Name} className="product-image" />
              </Col>
              <Col xs={8} md={8} l={8} className="product-info">
                <h5 className="product-title">{product.Name}</h5>
                <p className="product-size-color">Adet: {product.Count}</p>
                {(() => {
                  const requestedQty = getRequestedQuantity(product.Id);
                  return requestedQty ? (
                    <p className="product-size-color" style={{ color: '#28a745', fontWeight: '500' }}>
                      Talep Adedi: {requestedQty}
                    </p>
                  ) : null;
                })()}
                <p className="product-size-color-price">Fiyat: {formatCurrency(product.BasePrice)}</p>
                {product?.Count > 1 && (
                  <div className="d-flex align-items-center mt-2" onClick={(e) => e.stopPropagation()}>
                    <Button
                      variant="light"
                      size="sm"
                      onClick={(e) => decreaseQty(e, product)}
                      disabled={isFullyRequested(product) || hasSubmittedClaimForProduct(product.Id)}
                    >
                      -
                    </Button>
                    <span className="mx-2">{Math.min(quantities[product.Id] || 1, getMaxSelectableQuantity(product))}</span>
                    <Button
                      variant="light"
                      size="sm"
                      onClick={(e) => increaseQty(e, product)}
                      disabled={
                        isFullyRequested(product) ||
                        hasSubmittedClaimForProduct(product.Id) ||
                        (quantities[product.Id] || 1) >= getMaxSelectableQuantity(product)
                      }
                    >
                      +
                    </Button>
                  </div>
                )}
                {hasSubmittedClaimForProduct(product.Id) && !isFullyRequested(product) && (
                  <p className="product-size-color mt-1" style={{ color: '#6c757d', fontSize: '0.85rem' }}>
                    Ek iade için ürüne tıklayarak yeni talep başlatın.
                  </p>
                )}
              </Col>
              <Col xs={1} md={1} l={1}>
                      {isFullyRequested(product) && (
                        <FaRegCircleCheck size={24} className="check-icon" />
                      )}
              </Col>
            </Row>
          </ListGroup.Item>
        ))}
      </ListGroup>
      </Col>
    </Row>

    
      <Row className="w-100 justify-content-center">
          <Col  md={6} >
          {process &&
            <Button className='mt-3 w-100 transparent-black-button'
              onClick={()=>navigate('/summary-list')}
              > devam et </Button>
            }
          </Col>
        </Row>
   
    </Container>

        {selectedProduct && (
        <ProductModal
          showModal={showModal}
          handleClose={handleCloseModal}
          product={selectedProduct}
          setShowModal={setShowModal}
        />
        )}

  </>
  );
};

export default ProductList;
